<template>
  <div class="guest_item">
    <div class="top_bar">
      <div class="left">{{slogan}}</div>
      <div class="right">
        <div
          v-if="vSrc"
          class="show_time"
          :style="vSrc?'background:#FFF url(https://summit-img.geekpark.net/r2020/m-play_btn.svg) no-repeat bottom center/cover;':''"
          @click="playCurVideo(vSrc)"
        ></div>
        <div class="title_wrapper">
          <img :src="title" />
        </div>
      </div>
    </div>
    <!-- 嘉宾信息 -->
    <div class="guest_info">
      <div class="avatar">
        <img :src="avatar1" />
      </div>
      <div class="info">
        <div :class="['top',!achievement1?' full_height_top':'']">
          <div class="name">{{name1}}</div>
          <div v-if="id1" class="id" :style="{backgroundColor:themeColor}">{{id1}}</div>
        </div>
        <div v-if="achievement1" class="bottom">
          <pre class="achievement" :style="{color:themeColor}">{{achievement1}}</pre>
          <div class="sub_achievement">{{sub_achievement1}}</div>
        </div>
      </div>
    </div>

    <div v-if="avatar2" class="guest_info guest_info_bottom">
      <div class="avatar">
        <img :src="avatar2" />
      </div>
      <div class="info">
        <div class="top">
          <div class="name">{{name2}}</div>
          <div v-if="id2" class="id" :style="{backgroundColor:themeColor}">{{id2}}</div>
        </div>
        <div class="bottom">
          <pre class="achievement" :style="{color:themeColor}">{{achievement2}}</pre>
          <div v-if="sub_achievement2" class="sub_achievement">{{sub_achievement2}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GuestItem",
  props: {
    type: "",
    title: "",
    show_time: "",
    rightArrow: "",
    slogan: "",
    themeColor: "",
    avatar1: "",
    identity1: "",
    name1: "",
    id1: "",
    achievement1: "",
    sub_achievement1: "",
    avatar2: "",
    identity2: "",
    name2: "",
    id2: "",
    achievement2: "",
    sub_achievement2: "",
    vSrc: "",
  },
  computed: {
    curVideoSrc() {
      return this.$store.state.curVideoSrc;
    },
  },
  methods: {
    playCurVideo(vSrc) {
      if (!vSrc) return;
      const vIframeWrapper = document.getElementById(
        "geekpark_video_iframe_wrapper"
      );
      const vIframe = document.getElementById("geekpark_video_iframe");
      if (vIframeWrapper.style.display === "none") {
        vIframeWrapper.style.display = "block";
        vIframe.src = this.vSrc;
        this.$store.commit("handleVSrcToggle", this.vSrc);
      } else {
        if (vSrc === this.curVideoSrc) return;
        vIframe.src = this.vSrc;
        this.$store.commit("handleVSrcToggle", this.vSrc);
      }
    },
  },
};
</script>

<style scoped lang="less">
.guest_item {
  border: 1px solid #000;
  margin-bottom: 14px;
  .top_bar {
    display: flex;
    border-bottom: 1px solid #000;
    .left {
      border-right: 1px solid #000;
      flex: 1;
      padding: 0px 4px 0px 20px;
      font-size: 16px;
      font-weight: bold;
      display: flex;
      align-items: center;
      line-height: 1.1em;
    }
    .right {
      .title_wrapper {
        padding: 4px 10px;
        img {
          width: 48px;
          height: auto;
        }
      }
      .show_time {
        font-family: "ParaTypeStapelExtraBold";
        font-size: 18px;
        font-weight: bold;
        padding: 4px 10px;
        line-height: 1em;
        color: #fff;
        height: 28px;
      }
    }
  }
  .guest_info {
    display: flex;
    &.guest_info_bottom {
      border-top: 1px solid #000;
    }
    .avatar {
      width: 72px;
      height: 72px;
      border-right: 1px solid #000;
      overflow: hidden;
      img {
        width: auto;
        height: 100%;
      }
    }
    .info {
      flex: 1;
      .top {
        display: flex;
        align-items: center;
        height: 34px;
        &.full_height_top {
          height: 100%;
        }
        .name {
          width: 130px;
          padding-left: 20px;
          line-height: 1em;
          font-size: 20px;
          font-weight: bold;
        }
        .id {
          color: #fff;
          flex: 1;
          font-size: 12px;
          font-weight: bold;
          line-height: 34px;
          padding-left: 20px;
          border-left: 1px solid #000;
        }
      }
      .bottom {
        display: flex;
        align-items: center;
        height: 38px;
        border-top: 1px solid #000;
        .achievement {
          margin-right: 10px;
          font-size: 14px;
          font-weight: bold;
          padding-left: 20px;
          line-height: 1.2em;
          white-space: pre-wrap;
          min-width: 50px;
        }
        .sub_achievement {
          font-size: 12px;
          color: #666666;
        }
      }
    }
  }

  .video_wrapper {
    position: fixed;
    padding: 20% 31%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #000;
    z-index: 99999;
    .close_video_btn {
      position: absolute;
      top: -1vw;
      right: -1vw;
      height: 3vw;
      width: auto;
      &:hover {
        cursor: pointer;
      }
    }
    .innner_black_bg {
      background: #000;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
    .innner_yellow_border {
      content: " ";
      display: block;
      width: 100%;
      height: 100%;
      background: #faf04e;
      border: 1px solid #000;
      position: absolute;
      bottom: -0.5vw;
      right: -0.5vw;
    }
  }
}
</style>